<template>
<div class="chapter">
<div class="inner_page">
<p class="indent"><a id="file_025">The X stood for experimental. The first F denoted the type of aircraft—a fighter. The second F was the company designation, assigned to the newcomer Grumman Aircraft Engineering Corporation. Logically, Boeing had B and Curtiss held C. However, </a><a id="page_15">Grumman had lost G because the navy had had previous dealings with the Great Lakes Aeronautical Corporation. Grumman aircraft, including the F6F Hellcat, carried the F designation within their official navy monikers for many years to come.</a></p><a id="page_15">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_025.vue?2b3f41ec